/* unplugin-vue-components disabled */import { render } from "./ClassWorkView.vue?vue&type=template&id=d5cb5502&scoped=true"
import script from "./ClassWorkView.vue?vue&type=script&lang=js"
export * from "./ClassWorkView.vue?vue&type=script&lang=js"

import "./ClassWorkView.vue?vue&type=style&index=0&id=d5cb5502&lang=scss&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5cb5502"]])

export default __exports__